module.exports = __webpack_public_path__ + "static/media/pestana.025b0ec6.webp";